import client from "../libs/HttpClient";
class OurproductService {
  static getOurproductData() {
    return client.get("/our-product-list");
  }
  
}
export { OurproductService };
